import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import { useIsWhiteboardFeatureEnabled } from '@confluence/whiteboard-utils/entry-points/useIsWhiteboardFeatureEnabled';
import { useIsAllowedToCreateWhiteboard } from '@confluence/content-types-utils/entry-points/useIsAllowedToCreateWhiteboard';

export const useIsEligibleCreateNewWhiteboard = () => {
	const { edition } = useSessionData();

	const { isWhiteboardFeatureEnabled } = useIsWhiteboardFeatureEnabled();
	const isWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');

	const isAllowedToCreateWhiteboard = useIsAllowedToCreateWhiteboard();

	return {
		isEligibleCreateNewWhiteboard:
			edition !== ConfluenceEdition.FREE && isWhiteboardsEnabled && isAllowedToCreateWhiteboard,
	};
};
